import { render } from "./Dash.vue?vue&type=template&id=55dd5351&scoped=true"
import script from "./Dash.vue?vue&type=script&lang=js"
export * from "./Dash.vue?vue&type=script&lang=js"

import "./Dash.vue?vue&type=style&index=0&id=55dd5351&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55dd5351"]])

export default __exports__